import React from 'react';
import styled from '@emotion/styled';
import Responsive from '../../../../../ui/utils/Responsive';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { CreateUserAccountForm } from './CreateUserAccountForm';
import {
	getOverlapWithHeaderStyles,
	SolidContentWrap,
} from '../../../../shared/components';

export const CreateUserAccount = () => {
	const { t } = useTranslation();

	return (
		<Wrap>
			<h3>{t('web_parking_confirmation_save_booking_header')}</h3>
			<CreateUserAccountForm />
		</Wrap>
	);
};

const Wrap = styled(SolidContentWrap)`
	${getOverlapWithHeaderStyles}

	margin-bottom: 40px;

	@media ${Responsive.getMediaQueryForBreakpoint('mobileXL')} {
		margin-bottom: 24px;
	}
`;
